import React from 'react';
import { useParams } from 'react-router-dom';
import { useNewsData } from '../../../../hooks/useNewsData';
import ArticleRenderer from './ArticleRenderer';
import { newsDateConverter } from '../../../../components/converter';
import './NewsArticle.css';

const NewsArticle = () => {
    const { newsTitle } = useParams();
    const { news, isLoading } = useNewsData();
    const article = news.find(item => item.slug === newsTitle);

    return (
        <div className="article-page">
                {isLoading && <p>Loading news article...</p>}
                {article && (
                    <div className="article-page__container">
                        <img src={article.img} alt="Artikel Bild"/>
                        <article className="article-page__content">
                            <h1>{article.title}</h1>
                            <div className="article-page__info">
                                <div className="article-page__time">
                                    <span>{newsDateConverter(article.publishedAt)} | {article.readTime}</span>
                                </div>
                                <div className="article-page__author">
                                    <span>Erstellt von: {article.author}</span>
                                </div>
                            </div>
                                <ArticleRenderer blocks={article.blocks}/>
                        </article>
                    </div>
                )}
        </div>
    );
}

export default NewsArticle;
